import { PaginateQuery } from "core/resources/types/shared";

export interface EncomendaDto {
  id: string;
  createdAt: string;
  descricao: string;
  observacao: string;
  condominioPodeConfirmar?: boolean;
  dataChegadaCondominio: string | null;
  status: {
    id: EncomendaStatusEnum;
    nome: string;
  };
  unidade: {
    id: string;
    numero: string;
    blocoQuadra?: string | null;
  };
  pessoa: { nome: string; imagemUrl: string; celular: string; email: string };
  origem: string;
  arquivos:
    | {
        referencia: string;
        mimetype: string;
        id: string;
        nome: string;
      }[]
    | null;
}

export type CalendarioEncomendaEvent = EncomendaDto & {
  backgroundColor?: string;
  title: string;
  start: string;
  end?: string;
};

export interface DashboardEncomenda {
  entregue: number;
  aguardandoRecebimento: number;
  recebidoPortaria: number;
  recebidoSalaDeEncomendas: number;
}

export interface EncomendaForm {
  id: string;
  nome: string;
  datadeCadastro: string;
  pessoaId: string;
  observacao?: string;
  unidadeId: string;
  gruposUnidadesIds?: string[];
  descricao?: string | null;
  files?: File[];
}

export interface ListarEncomendaQuery extends PaginateQuery {
  statusId?: EncomendaStatusEnum | EncomendaStatusEnum[];
  unidadeId?: string;
  pessoaId?: string;
  mes?: string;
  dataInicio?: string;
  dataFim?: string;
  orderBy?: string;
  orderDirection?: string;
}

export enum EncomendaStatusEnum {
  AguardandoRecebimento = "AB04913A-1C46-4EBE-BFB3-F311EE9E0000",
  RecebidaNaPortaria = "AB04913A-1C46-4EBE-BFB3-F311EE9E0001",
  RecebidaNaSalaDeEncomendas = "AB04913A-1C46-4EBE-BFB3-F311EE9E0004",
  EntregueAoMorador = "AB04913A-1C46-4EBE-BFB3-F311EE9E0002",
  EntregaConfirmadaPeloMorador = "AB04913A-1C46-4EBE-BFB3-F311EE9E0003",
}
